import React from 'react';
import { ReactComponent as  InnovationLogo } from '../../assets/images/logo.svg';
import InstagramLogo from '../../assets/icons/instagram.svg';
import TwitterLogo from '../../assets/icons/twitter.svg';
import YoutubeLogo from '../../assets/icons/youtube.svg';
import useWindowSize from '../../hooks/useWindowSize';

const Footer = () => {
  const  { width } = useWindowSize();

  return (
    <div className="container-fluid bg-success mb-0 pb-3 pt-3">
      <div className="container">
        <div className="row justify-content-between align-items-center mb-5">
          <div className="col-12 col-md-6 order-1 order-md-0 mt-3">
            <div>
              <InnovationLogo
                width= { width < 700 ? "84px" : "113px" }
                height={ width < 700 ? "60px" : "80px" }
              />
            </div>
            <p className="mt-2 text-secondary" style={{ width: '25rem' }}>
              We are number one distributor of quality caps, preforms and bottles in Nigeria.
            </p>
            <div className="d-flex justify-content-start align-items-center">
              <div className="d-flex justify-content-center align-items-center rounded-circle bg-dark p-2" style={{ marginRight: '1rem' }}>
                <a className="text-decoration-none" href="https://instagram.com/" target="_blank" rel="noreferrer">
                  <img src={InstagramLogo} width="24px" height="24px" alt="Instagram" />
                </a>
              </div>
              <div className="d-flex justify-content-center align-items-center rounded-circle bg-dark p-2" style={{ marginRight: '1rem' }}>
                <a className="text-decoration-none" href="https://twitter.com" target="_blank" rel="noreferrer">
                  <img src={TwitterLogo} width="24px" height="24px" alt="Twitter" />
                </a>
              </div>
              <div className="d-flex justify-content-center align-items-center rounded-circle bg-dark p-2 mr-4" style={{ marginRight: '1rem' }}>
                <a className="text-decoration-none" href="https://youtube.com" target="_blank" rel="noreferrer">
                  <img src={YoutubeLogo} width="24px" height="24px" alt="Youtube" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <h3 className="text-info mb-4">
              <strong>
                Stay upto date with our Newsletter
              </strong>
            </h3>
            <div className="d-flex justify-content-start align-items-center">
              <div className="form-group">
                <input type="email" id="" placeholder="Your email address" className="form-control bg-white rounded-end rounded-3 p-3" />
              </div>
              <div>
                <button type="submit" className="btn btn-info rounded-start rounded-3 p-3">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-info">
          Copyright © 2021 Innovation Associates Nig. Ltd.
        </p>
      </div>
    </div>
  );
};

export { Footer };
